import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {
  RankingCategoryItem,
  RankSortingLocatorComponent,
  RankSortingTypeEnum,
  ViewDataService,
  WaHelperService,
  WCupRankingCategoryListLocator,
  WCupSeasonItem,
  WCupSeasonLocator,
  WorldRankingCategoryListLocator
} from 'world-archery-lib';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseService {
  /**
   *
   * Subject that constains all data avaible for show into the combobox of archers category
   * @type {Subject<Array<RankingCategoryItem>>}
   * @memberof FiltersSeriesEliteRankingService
   */
  worldCupRankingsCategoriesOptions: Subject<
    Array<RankingCategoryItem>
  > = new BehaviorSubject([] as any);

  /**
   *
   * BehaviorSubject that retrieve the selected data into the combobox of archers category
   * @type {BehaviorSubject<RankingCategoryItem>}
   * @memberof FiltersSeriesEliteRankingService
   */
  worldCupRankingsCategories: BehaviorSubject<
    RankingCategoryItem
  > = new BehaviorSubject({} as any);

  /**
   *
   * Subject that constains all data avaible for show into the season combobox of archers
   * @type {BehaviorSubject<WCupSeasonItem>}
   * @memberof FiltersSeriesEliteRankingService
   */
  worldCupRankingSeason: BehaviorSubject<WCupSeasonItem> = new BehaviorSubject(
    {} as any
  );
  /**
   *
   *  BehaviorSubject that retrieve the selected data into the combobox of archers category
   * @type {BehaviorSubject<Array<WCupSeasonItem>>}
   * @memberof FiltersSeriesEliteRankingService
   */
  worldCupRankingSeasonOptions: BehaviorSubject<
    Array<WCupSeasonItem>
  > = new BehaviorSubject([] as any);

  /**
   *
   * Subject that constains the text filters content.
   * @type {Subject<string>}
   * @memberof FiltersSeriesEliteRankingService
   */
  textFilter: Subject<string> = new Subject();
  protected textSubject: BehaviorSubject<string> = new BehaviorSubject('');
  protected _orderValue: RankSortingTypeEnum = undefined;
  readonly sortLocator = new RankSortingLocatorComponent();

  protected orderSubject: BehaviorSubject<
    RankSortingLocatorComponent
  > = new BehaviorSubject(this.sortLocator);

  constructor(
    protected views: ViewDataService,
    protected helper: WaHelperService
  ) {}
  abstract generateDefaultValues();

  get textValue(): Observable<string> {
    return this.textSubject.asObservable().pipe(
      debounceTime(500),
      distinctUntilChanged()
    );
  }
  public modifyTextValue(value: string) {
    this.textSubject.next(value);
  }
  get orderValue(): Observable<RankSortingLocatorComponent> {
    return this.orderSubject.asObservable();
  }
  public modifyOrderValue() {
    this.orderSubject.next(this.sortLocator);
  }
}
